import { isNumber } from 'lodash'

export const parseBackgroundPosition = (position?: string | number): number => {
  const positionIsMissing =
    position === undefined || position === null || position === ''
  if (positionIsMissing) {
    return 0
  }

  if (isNumber(position)) {
    return position
  }

  const positionString = String(position)

  if (positionString.includes('%')) {
    return 0
  }

  if (positionString.includes('px')) {
    return parseFloat(positionString)
  }

  const parsedNumber = parseFloat(positionString)

  if (isNaN(parsedNumber)) {
    return 0
  }

  return parsedNumber
}

export default parseBackgroundPosition
